import React from 'react';
import classNames from 'classnames';
import { SummaryEndProps } from '../summary-drawer-types';
import styles from '../summary-drawer.module.scss';
import { CUIText } from '@dotcom/crown-ui';

export const SummaryFooter = ({ data }: SummaryEndProps): React.ReactElement => {
  const classes = classNames(styles['summary-row'], styles['summary-footer']);

  return (
    <div className={classes} data-testid="summary-grid-end">
      <div className={styles.detail}>
        <div className={styles['title-container']}>
          <CUIText as="span" color="textPrimary">
            {data.title}
          </CUIText>
        </div>
        <div className={styles['subtitle-container']}>
          <CUIText as="span" color="textPrimary">
            {data.detail}
          </CUIText>
        </div>
      </div>
    </div>
  );
};
